(function () {
  function init(section) {
    initGallery(section);
    initBuyBox(section);
    initStickyAtc(section);
    initBadgeLink(section);
    initFrontrowBadge(section);
  }

  // The FrontrowMD sticker renders at a fixed natural width (≈437px). On narrow
  // viewports that's wider than the gallery slide, so we scale the whole badge
  // down (via CSS `zoom`) to fit instead of constraining its width — constraining
  // width reflows the cross-origin content and clips it (QA: frontrow on mobile).
  var FRONTROW_NATURAL_WIDTH = 437;

  function fitFrontrowBadge(section) {
    var badge = section.querySelector('.oddit-section-main-product__frontrow-badge');
    if (!badge) return;
    var iframe = badge.querySelector('iframe');
    if (!iframe) return;
    var host = badge.closest('.oddit-section-main-product__slide') || badge.parentElement;
    if (!host) return;
    // 16px inset on each side (matches the badge's left offset) for breathing room.
    var available = host.clientWidth - 32;
    if (available <= 0) return;
    // The iframe's natural (pre-transform) size as rendered by the widget.
    // transform:scale() doesn't change offsetWidth/Height, so these stay stable
    // across recomputes. Fall back to the known natural width until it loads.
    var naturalW = iframe.offsetWidth || FRONTROW_NATURAL_WIDTH;
    var naturalH = iframe.offsetHeight;
    if (!naturalW) return; // widget not ready yet — a later tick will catch it
    var scale = Math.min(1, available / naturalW);
    badge.style.setProperty('--oddit-fr-scale', scale.toFixed(4));
    // Size the clipping wrapper to the scaled iframe so it occupies the right
    // footprint and trims any overflow (incl. iOS's iframe content-expansion).
    badge.style.width = Math.round(naturalW * scale) + 'px';
    if (naturalH) badge.style.height = Math.round(naturalH * scale) + 'px';
  }

  function initFrontrowBadge(section) {
    if (!section.querySelector('.oddit-section-main-product__frontrow-badge')) return;
    fitFrontrowBadge(section);
    if (section.dataset.odditFrBound === 'true') return;
    section.dataset.odditFrBound = 'true';

    var resizeTimer = null;
    function recompute() {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        fitFrontrowBadge(section);
      }, 150);
    }
    window.addEventListener('resize', recompute);
    window.addEventListener('orientationchange', recompute);
    window.addEventListener('load', recompute);
    // The widget iframe loads + sizes itself asynchronously, so poll a few times
    // after init until its measured dimensions settle (esp. on-device).
    [200, 600, 1200, 2500].forEach(function (delay) {
      window.setTimeout(function () { fitFrontrowBadge(section); }, delay);
    });
    var iframe = section.querySelector('.oddit-section-main-product__frontrow-badge iframe');
    if (iframe) iframe.addEventListener('load', recompute);
  }

  window.OdditMainProduct = { init: init };

  // "View clinicians" in the clinicians badge → smooth-scroll to the FrontrowMD
  // testimonials section. Done in JS because the richtext anchor href can be
  // sanitized away, and we target the section's stable class (QA: ALY-52/61).
  function initBadgeLink(section) {
    var badge = section.querySelector('.oddit-section-main-product__badge');
    if (!badge) return;
    var link = badge.querySelector('a');
    if (!link) return;
    link.addEventListener('click', function (e) {
      var target = document.querySelector('.shopify-section-oddit-frontrow-testimonials');
      if (!target) {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) === '#') target = document.getElementById(href.slice(1));
      }
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function initStickyAtc(section) {
    var bar = section.querySelector('[data-sticky-atc]');
    var mainBtn = section.querySelector('[data-add-to-cart]');
    if (!bar || !mainBtn || bar.dataset.odditBound === 'true') return;
    bar.dataset.odditBound = 'true';

    var stickyAdd = bar.querySelector('[data-sticky-add]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (stickyAdd.disabled) return;
        // Add directly (rather than proxying the main button) so the sticky
        // button shows its own "Adding…" text + fade. The main ATC's data
        // attributes hold the current variant/plan, kept in sync by recompute().
        var variantId = mainBtn.getAttribute('data-variant-id');
        if (!variantId) return;
        var sellingPlan = mainBtn.getAttribute('data-selling-plan');
        var label = stickyAdd.querySelector('[data-sticky-add-label]');
        var original = label ? label.textContent : '';
        // Lock the current width so the button doesn't shrink when the shorter
        // "Adding…" label replaces "Add to Cart • $price" (QA feedback).
        stickyAdd.style.width = stickyAdd.offsetWidth + 'px';
        stickyAdd.disabled = true; // :disabled fades it to 0.5 opacity via CSS transition
        if (label) label.textContent = 'Adding…';
        cartAdd(variantId, sellingPlan).then(restore, restore);
        function restore() {
          stickyAdd.disabled = false;
          stickyAdd.style.width = '';
          if (label) label.textContent = original;
        }
      });
    }

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (!entry) return;
      // Only show after the main ATC has scrolled ABOVE the viewport top.
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', scrolledPast);
    }, { threshold: 0 });
    io.observe(mainBtn);
  }

  function initGallery(section) {
    var track = section.querySelector('[data-gallery-track]');
    var counter = section.querySelector('[data-gallery-counter]');
    var prevBtn = section.querySelector('[data-gallery-prev]');
    var nextBtn = section.querySelector('[data-gallery-next]');
    if (!track) return;

    var slides = track.children;
    var total = slides.length;
    if (total === 0) return;
    var current = 0;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function update() {
      if (counter) {
        counter.textContent = pad(current + 1) + '/' + pad(total);
      }
      var slide = slides[current];
      if (slide && typeof slide.scrollIntoView === 'function') {
        // Only scroll within the track if it's scrollable
        if (track.parentElement.scrollWidth > track.parentElement.clientWidth) {
          slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        current = (current - 1 + total) % total;
        update();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        current = (current + 1) % total;
        update();
      });
    }

    update();
  }

  // ---------------------------------------------------------------------------
  // Buy box: supply (variant) selection, subscribe/one-time toggle, selling
  // plan selection, live price updates, and add-to-cart.
  //
  // All money strings come pre-formatted from the [data-mp-variants] JSON, so
  // the JS never formats currency itself.
  // ---------------------------------------------------------------------------

  function initBuyBox(section) {
    var data = parseVariants(section);
    var buyBox = section.querySelector('[data-buy-box]');

    var supplyOptions = section.querySelectorAll('.oddit-section-main-product__supply-option');
    var purchaseOptions = section.querySelectorAll('[data-purchase-mode]');
    var planDropdown = section.querySelector('[data-mp-plan-dropdown]');
    var planToggle = section.querySelector('[data-mp-plan-toggle]');
    var planMenu = section.querySelector('[data-mp-plan-menu]');
    var planLabel = section.querySelector('[data-mp-plan-label]');

    var initialPlanOption = section.querySelector('[data-mp-plan-option][aria-selected="true"]');
    var state = {
      variantId: buyBox ? buyBox.getAttribute('data-default-variant-id') : '',
      mode: buyBox ? (buyBox.getAttribute('data-default-mode') || 'onetime') : 'onetime',
      planId: initialPlanOption ? initialPlanOption.getAttribute('data-plan-id') : ''
    };

    function syncFromInputs() {
      var checkedSupply = section.querySelector('[data-supply-option] input:checked');
      if (checkedSupply) {
        state.variantId = checkedSupply.value;
        supplyOptions.forEach(function (o) {
          var isMatch = o.contains(checkedSupply);
          o.classList.toggle('oddit-section-main-product__supply-option--active', isMatch);
        });
      } else if (supplyOptions.length) {
        // The default variant may be excluded from the selector (e.g. an inline
        // option) — fall back to the first rendered supply option.
        var firstSupply = section.querySelector('[data-supply-option][data-variant-id]');
        if (firstSupply) {
          state.variantId = firstSupply.getAttribute('data-variant-id');
          firstSupply.classList.add('oddit-section-main-product__supply-option--active');
          var firstInput = firstSupply.querySelector('.oddit-section-main-product__supply-input');
          if (firstInput) firstInput.checked = true;
        }
      }

      var checkedPurchase = section.querySelector('[data-purchase-mode] .oddit-section-main-product__purchase-input:checked');
      if (checkedPurchase) {
        var purchaseOpt = checkedPurchase.closest('[data-purchase-mode]');
        if (purchaseOpt) state.mode = purchaseOpt.getAttribute('data-purchase-mode') || state.mode;
      }
      selectPurchaseMode(state.mode);
    }

    function currentVariant() {
      return data && state.variantId ? data[state.variantId] : null;
    }

    function currentPlan(variant) {
      if (!variant || !variant.plans || !variant.plans.length) return null;
      for (var i = 0; i < variant.plans.length; i++) {
        if (String(variant.plans[i].id) === String(state.planId)) return variant.plans[i];
      }
      // Selected plan isn't offered on this variant — fall back to its first plan.
      return variant.plans[0];
    }

    function setText(sel, text) {
      var el = section.querySelector(sel);
      if (el && text != null) el.textContent = text;
    }

    function setToggle(sel, text, show) {
      var el = section.querySelector(sel);
      if (!el) return;
      el.textContent = text || '';
      el.style.display = show ? '' : 'none';
    }

    function updatePlanLabel(variant) {
      if (!planLabel) return;
      var plan = currentPlan(variant);
      if (plan) planLabel.textContent = plan.name;
    }

    function rebuildPlanOptions(variant) {
      if (!planMenu || !variant) return;
      var plans = variant.plans || [];
      var prev = state.planId;
      var stillThere = plans.some(function (p) { return String(p.id) === String(prev); });
      if (!stillThere && plans.length) prev = String(plans[0].id);
      state.planId = prev;

      planMenu.innerHTML = '';
      plans.forEach(function (p) {
        var li = document.createElement('li');
        li.className = 'oddit-section-main-product__delivery-item';
        li.setAttribute('role', 'option');
        li.setAttribute('data-mp-plan-option', '');
        li.setAttribute('data-plan-id', p.id);
        var sel = String(p.id) === String(prev);
        li.setAttribute('aria-selected', sel ? 'true' : 'false');
        if (sel) li.classList.add('oddit-section-main-product__delivery-item--selected');
        li.textContent = p.name;
        planMenu.appendChild(li);
      });
      updatePlanLabel(variant);
    }

    function openMenu() {
      if (!planMenu) return;
      planMenu.hidden = false;
      if (planToggle) planToggle.setAttribute('aria-expanded', 'true');
      if (planDropdown) planDropdown.classList.add('is-open');
    }

    function closeMenu() {
      if (!planMenu) return;
      planMenu.hidden = true;
      if (planToggle) planToggle.setAttribute('aria-expanded', 'false');
      if (planDropdown) planDropdown.classList.remove('is-open');
    }

    function recompute() {
      var variant = currentVariant();
      if (!variant) return;

      var useSub = state.mode === 'subscribe' && variant.plans && variant.plans.length;
      var plan = useSub ? currentPlan(variant) : null;

      var price = useSub ? plan.price : variant.price;
      var compare = useSub ? plan.compare : variant.compare;
      var savePct = useSub ? plan.save_pct : variant.save_pct;
      var available = variant.available;

      // Main price block
      setText('[data-mp-price]', price);
      setToggle('[data-mp-compare]', compare, compare && compare !== price);
      var saveEl = section.querySelector('[data-mp-save]');
      if (saveEl) {
        if (savePct && savePct > 0) {
          var prefix = saveEl.getAttribute('data-save-prefix') || 'Save';
          saveEl.textContent = prefix + ' ' + savePct + '%';
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }

      // Purchase cards: subscribe price reflects the selected plan; one-time is
      // always the variant's own price.
      var subPlan = currentPlan(variant);
      if (subPlan) {
        setText('[data-mp-sub-price]', subPlan.price);
        setToggle('[data-mp-sub-compare]', subPlan.compare, subPlan.save_pct > 0 && subPlan.compare !== subPlan.price);
      }
      setText('[data-mp-onetime-price]', variant.price);

      // Per-bottle price and savings badge on each supply option, using the
      // effective (selected subscription or one-time) price for that variant.
      supplyOptions.forEach(function (opt) {
        var vid = opt.getAttribute('data-variant-id');
        if (!vid || !data || !data[vid]) return;
        var v = data[vid];
        var vPlan = useSub ? currentPlan(v) : null;

        var priceEl = opt.querySelector('[data-mp-supply-price]');
        if (priceEl) {
          var perBottle = vPlan ? vPlan.per_bottle : v.per_bottle;
          var full = vPlan ? vPlan.price : v.price;
          priceEl.textContent = perBottle ? perBottle + '/bottle' : full;
        }

        var savingsEl = opt.querySelector('[data-mp-supply-savings]');
        if (savingsEl) {
          // Subscribe: amount saved vs one-time. One-time: compare-at sale amount.
          var amount = vPlan ? vPlan.save_amount : v.save_amount;
          if (amount) {
            var prefix = savingsEl.getAttribute('data-save-prefix') || 'Save';
            savingsEl.textContent = prefix + ' ' + amount;
            savingsEl.style.display = '';
          } else {
            savingsEl.style.display = 'none';
          }
        }
      });

      // Supply label + variant-derived subtitle (header + sticky bar)
      setText('[data-mp-supply-current]', variant.title);
      setText('[data-mp-subtitle-secondary]', variant.supply_name);
      setText('[data-mp-sticky-supply]', variant.supply_name);

      // Add to cart
      var btn = section.querySelector('[data-add-to-cart]');
      if (btn) {
        btn.setAttribute('data-variant-id', state.variantId);
        btn.setAttribute('data-selling-plan', useSub && plan ? plan.id : '');
        var label = btn.querySelector('[data-button-label]');
        if (available) {
          btn.disabled = false;
          if (label) {
            var cta = btn.getAttribute('data-cta-text') || 'Add to Cart';
            label.textContent = cta + ' • ' + price;
          }
        } else {
          btn.disabled = true;
          if (label) label.textContent = 'Sold out';
        }
      }

      // Mirror availability + price onto the sticky bar's ADD button so it
      // reads e.g. "Add to Cart • $77.59" like the main button (QA feedback).
      var stickyAdd = section.querySelector('[data-sticky-add]');
      if (stickyAdd) {
        stickyAdd.disabled = !available;
        var stickyLabel = stickyAdd.querySelector('[data-sticky-add-label]');
        if (stickyLabel) {
          if (available) {
            var stickyCta = stickyAdd.getAttribute('data-cta-text') || 'Add to Cart';
            stickyLabel.textContent = price ? stickyCta + ' • ' + price : stickyCta;
          } else {
            stickyLabel.textContent = 'Sold out';
          }
        }
      }
    }

    function selectPurchaseMode(mode) {
      state.mode = mode;
      purchaseOptions.forEach(function (o) {
        var isMatch = o.getAttribute('data-purchase-mode') === mode;
        o.classList.toggle('oddit-section-main-product__purchase-option--active', isMatch);
        var input = o.querySelector('.oddit-section-main-product__purchase-input');
        if (input) input.checked = isMatch;
      });
    }

    // Supply / variant selection (works for variant-driven options; manual
    // fallback blocks have no data-variant-id and just toggle visually).
    supplyOptions.forEach(function (option) {
      var input = option.querySelector('.oddit-section-main-product__supply-input');
      option.addEventListener('click', function () {
        if (input && input.disabled) return;
        supplyOptions.forEach(function (o) {
          o.classList.remove('oddit-section-main-product__supply-option--active');
        });
        option.classList.add('oddit-section-main-product__supply-option--active');
        if (input) input.checked = true;

        var variantId = option.getAttribute('data-variant-id');
        if (variantId) {
          state.variantId = variantId;
          rebuildPlanOptions(currentVariant());
          recompute();
        }
      });
    });

    // Subscribe / one-time toggle
    purchaseOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        selectPurchaseMode(option.getAttribute('data-purchase-mode'));
        recompute();
      });
    });

    // Selling plan dropdown — choosing a plan implies subscribe mode.
    if (planToggle) {
      planToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        selectPurchaseMode('subscribe');
        recompute();
        if (planMenu && planMenu.hidden) openMenu();
        else closeMenu();
      });
    }

    if (planMenu) {
      planMenu.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-mp-plan-option]');
        if (!opt) return;
        e.preventDefault();
        e.stopPropagation();
        state.planId = opt.getAttribute('data-plan-id');
        planMenu.querySelectorAll('[data-mp-plan-option]').forEach(function (o) {
          var sel = o === opt;
          o.setAttribute('aria-selected', sel ? 'true' : 'false');
          o.classList.toggle('oddit-section-main-product__delivery-item--selected', sel);
        });
        updatePlanLabel(currentVariant());
        closeMenu();
        selectPurchaseMode('subscribe');
        recompute();
      });
    }

    if (planDropdown) {
      document.addEventListener('click', function (e) {
        if (!planDropdown.contains(e.target)) closeMenu();
      });
      planDropdown.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMenu();
      });
    }

    syncFromInputs();
    rebuildPlanOptions(currentVariant());
    recompute();
    initAddToCart(section);
    initTrialLink(section);

    // Browser form-state restoration (bfcache or normal back-navigation) can
    // land after init — re-sync so only one option reads as selected (QA: ALY-46).
    window.addEventListener('pageshow', function () {
      syncFromInputs();
      rebuildPlanOptions(currentVariant());
      recompute();
    });
  }

  function parseVariants(section) {
    var el = section.querySelector('[data-mp-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function initAddToCart(section) {
    var btn = section.querySelector('[data-add-to-cart]');
    if (!btn || btn.dataset.odditBound === 'true') return;
    btn.dataset.odditBound = 'true';

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var sellingPlan = btn.getAttribute('data-selling-plan');
      var label = btn.querySelector('[data-button-label]');
      var original = label ? label.textContent : '';
      btn.disabled = true;
      if (label) label.textContent = 'Adding…';
      cartAdd(variantId, sellingPlan).then(added, restore);
      function added() {
        if (label) label.textContent = 'Added';
        setTimeout(restore, 1500);
      }
      function restore() {
        btn.disabled = false;
        if (label) label.textContent = original;
      }
    });
  }

  // Trial link under the ATC button — adds the "inline option" variant as a
  // one-time purchase (no selling plan).
  function initTrialLink(section) {
    var link = section.querySelector('[data-trial-add]');
    if (!link || link.dataset.odditBound === 'true') return;
    link.dataset.odditBound = 'true';

    link.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = link.getAttribute('data-variant-id');
      if (!variantId || link.classList.contains('is-loading')) return;
      link.classList.add('is-loading');
      cartAdd(variantId, '').then(done, done);
      function done() { link.classList.remove('is-loading'); }
    });
  }

  function cartAdd(variantId, sellingPlan) {
    var cart = window.OdditCartDrawer;
    if (cart && sellingPlan) {
      return cart.addMultipleToCart([{ id: variantId, quantity: 1, selling_plan: sellingPlan }]);
    }
    if (cart) {
      return cart.addToCart(variantId, 1);
    }
    var body = { id: Number(variantId), quantity: 1 };
    if (sellingPlan) body.selling_plan = Number(sellingPlan);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function () { window.location.href = '/cart'; });
  }

  function initAll() {
    var sections = document.querySelectorAll('.oddit-section-main-product');
    sections.forEach(init);
  }

  initAll();

  // Theme editor compatibility
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var section = null;
    if (e.target.classList && e.target.classList.contains('oddit-section-main-product')) {
      section = e.target;
    } else if (typeof e.target.querySelector === 'function') {
      section = e.target.querySelector('.oddit-section-main-product');
    }
    if (section) init(section);
  });
})();
